/* import __COLOCATED_TEMPLATE__ from './code-desc-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellCodeDescCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellCodeDescCellComponent = templateOnlyComponent<CellCodeDescCellSignature>();

export default CellCodeDescCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::CodeDescCell': typeof CellCodeDescCellComponent;
    'cell/code-desc-cell': typeof CellCodeDescCellComponent;
  }
}
